import { render, staticRenderFns } from "./MembershipUpdate.vue?vue&type=template&id=3b9564de&scoped=true&"
import script from "./MembershipUpdate.vue?vue&type=script&lang=ts&"
export * from "./MembershipUpdate.vue?vue&type=script&lang=ts&"
import style0 from "./MembershipUpdate.vue?vue&type=style&index=0&id=3b9564de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9564de",
  null
  
)

export default component.exports